module.exports = __webpack_public_path__ + "img/paraqueme.29f18a00.png";